import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./styles/style.css";
import "./styles/responsive.css";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova/theme.css";
import "primereact/resources/primereact.css";

// for local/test mode
// const stripePromise = loadStripe(
//   "pk_test_51QxbiKHW592Z3RS0kZ5CBgW8jxrasI7ie4UNsR0uaGgfJkSwAo1ObcHd6Ah14GPWyBmlz5yQ1VmGNBzIErYQwBri007nFfuTip"
// );

// for production/live mode
const stripePromise = loadStripe(
  "pk_live_51QxbiKHW592Z3RS0glRH72l3gJ2IOlTOVGwsArFKxZe8G2Yh5ON0tgMHTd6TrVjyDIP9aUafZcRamgqinXBe4FuI00BlRTssNj",
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Elements stripe={stripePromise}>
    <BrowserRouter>
      {/* <React.StrictMode> */}
      <App />
      {/* </React.StrictMode> */}
    </BrowserRouter>
  </Elements>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
